module.exports = __webpack_public_path__ + "static/media/family.4080f555.svg";